import { Trans, t } from '@lingui/macro'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Icon,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography
} from '@mui/material'
import {
  createSubsurvey,
  createSurveyTemplate,
  duplicateSurveyTemplate,
  findTemplates
} from 'app/services/sfAuth/sfData/sfSurvey'
import { ExpandButton } from 'mui-datatables'
import CustomDataTable from '../common-components/CustomDataTable'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { myI18n } from 'translation/I18nConnectedProvider'
import { getEmptyLangValues, hasEmptyValues } from 'utils'
import Loading from '../../../egret/components/EgretLoadable/Loading'
import ProgressSnackbar from '../common-components/CustomSnackbars'
import { getTitleTranslation } from '../common/TranslationsCommon'
import ConfigureMultilanguageTextField from '../internal/ConfigureMultilanguageTextField'
import ChangeSubtemplatesOrderDialogue from './ChangeSubtemplatesOrderDialogue'
import DeleteSurveyTemplateDialog from './DeleteSurveyTemplateDialog'
import { ExportImportSurveysTranslationsPanel } from './ExportImportSurveysTranslations'
import PrintableReadyToFillSurvey from './PrintableReadyToFillSurvey'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import SwapVerticalCircleOutlinedIcon from '@mui/icons-material/SwapVerticalCircleOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';


export const muiTableOverrides = {
  components: {
    MUIDataTableBodyCell: {
      root: {
        justifyContent: 'flex-end'
      }
    },
    MUIDataTableHeadCell: {
      fixedHeader: {
        zIndex: 0
      }
    },
    MUIDataTableSelectCell: {
      headerCell: {
        zIndex: 0
      },
      fixedLeft: {
        zIndex: 0
      }
    }
  }
}

export default function SurveyTemplates () {
  const [loaded, setLoaded] = useState(false)
  const [creatingDialogOpen, setCreatingDialogOpen] = useState(false)
  const [warningDialogOpen, setWarningDialogOpen] = useState(false)
  const [creatingSurveyOfType, setCreatingSurveyOfType] = useState('')
  const [dialogSurvey, setDialogSurvey] = useState(null)
  const [dialogChildrenIds, setDialogChildrenIds] = useState(null)
  const [list, setList] = useState([])
  const [panelsOpened, setPanelsOpened] = useState([])
  const [titleValue, setTitleValue] = useState(getEmptyLangValues())
  const [changeOrderDialogueOpen, setChangeOrderDialogueOpen] = useState(false)
  const user = useSelector(state => state.user)
  const history = useHistory()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [duplicating, setDuplicating] = useState()

  const fetchData = () => {
    return findTemplates().then(result => {
      const toSet = {}
      console.log('found templates', result)
      result.forEach(result => {
        const template = result.template
        if (template.Survey_Template_Joins_Survey_Template1__r === null) {
          toSet[template.Id] = {
            id: template.Id,
            translations: result.titleTranslation,
            name: getTitleTranslation(
              user.language,
              result.titleTranslation
            ),
            children: []
          }
        }
      })
      result.forEach(result => {
        const template = result.template
        if (template.Survey_Template_Joins_Survey_Template1__r !== null) {
          const join =
            template.Survey_Template_Joins_Survey_Template1__r.records[0]
          const order = join.Order__c
          toSet[join.Parent_Template__c].children.push({
            id: template.Id,
            order,
            join,
            translations: result.titleTranslation,
            name: getTitleTranslation(
              user.language,
              result.titleTranslation
            )
          })
        }
      })
      console.log('template list orig', toSet)
      setLoaded(true)
      setList(parseDataObj(toSet))
    })
  }

  useEffect(() => {
    const lang = user.language;
    const newList = list.map(obj => {
      const updatedObj = { ...obj };
      updatedObj.name = getTitleTranslation(lang, updatedObj.translations) || '';
      if (updatedObj.children) {
        updatedObj.children = updatedObj.children.map(child => {
          return { ...child, name: getTitleTranslation(lang, child.translations) || '' };
        });
      }
      return updatedObj;
    });
    setList(newList);
  }, [user.language]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const parseDataObj = (loadedObj) => {
    const toReturn = []
    for (const parentKey in loadedObj) {
      const field = {}
      field.id = loadedObj[parentKey].id
      field.translations = loadedObj[parentKey].translations
      field.name = loadedObj[parentKey].name
      field.children = loadedObj[parentKey].children
      field.actions = loadedObj[parentKey].id
      field.index = toReturn.length
      field.children.sort((a, b) => a.order - b.order)
      toReturn.push(field)
    }
    console.log('template list', toReturn)
    return toReturn
  }

  const editTemplate = (id, history) => {
    history.push(`/surveys/CreateSurvey/${id}`, { id })
  }

  const openWarningDialog = () => {
    setWarningDialogOpen(true)
  }

  const updateDialogsOpen = (rowIndex, added = false) => {
    const newPanels = [...panelsOpened]

    const indexOf = newPanels.indexOf(rowIndex)
    if (indexOf !== -1 && !added) {
      newPanels.splice(indexOf, 1)
    }

    newPanels.forEach((num, index) => {
      let newValue = num
      if (!added && num > rowIndex) {
        newValue -= 1
      } else if (added && num >= rowIndex) {
        newValue += 1
      }

      newPanels[index] = newValue
    })

    setPanelsOpened(newPanels)
    console.log('NOW OPENED', newPanels)
  }

  const closeDialog = () => {
    // this.setState({
    //   creatingDialogOpen: false,
    //   warningDialogOpen: false,
    //   creatingSurveyOfType: '',
    //   dialogChildrenIds: null,
    //   dialogSurvey: null,
    //   titleValue: getEmptyLangValues()
    // })
    setCreatingDialogOpen(false)
    setWarningDialogOpen(false)
    setCreatingSurveyOfType('')
    setDialogChildrenIds(null)
    setDialogSurvey(null)
    setTitleValue(getEmptyLangValues())
  }

  const data = list

  if (!loaded) {
    return <Loading />
  }

  return (
    <>
      <Dialog
        open={creatingDialogOpen}
        onClose={closeDialog}
        fullWidth
        maxWidth='sm'
      >
        <DialogTitle>
          <Trans>Create survey template</Trans>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            <Trans>
              Enter the name of a survey template you want to create
            </Trans>
          </DialogContentText>
          <ConfigureMultilanguageTextField
            value={titleValue}
            handleChange={e => {
              setTitleValue(e)
            }}
            maxCharacters={80}
            autoFocus
            label={<Trans>Template Name</Trans>}
          />
        </DialogContent>

        <DialogActions>
          <Grid container direction='row' justifyContent='space-evenly'>
            <Button
              variant='contained'
              color='primary'
              disabled={hasEmptyValues(titleValue, ['en', 'fr'])}
              onClick={() => {
                const creatingSnackbar = enqueueSnackbar('', {
                  variant: 'info',
                  persist: true,
                  content: key =>
                    ProgressSnackbar(
                      <Trans>Creating new survey template</Trans>
                    )
                })
                if (creatingSurveyOfType === 'child') {
                  createSubsurvey(
                    dialogSurvey.id,
                    titleValue,
                    dialogSurvey.children.length
                  ).then(result => {
                    fetchData().then(r => {
                      closeSnackbar(creatingSnackbar)
                      enqueueSnackbar(
                        <Trans>Survey template created!</Trans>,
                        {
                          variant: 'info'
                        }
                      )
                    })
                  })
                } else {
                  createSurveyTemplate(titleValue).then(result => {
                    fetchData().then(r => {
                      const newData = parseDataObj(list)
                      let addedindex = 0
                      newData.forEach((item, index) => {
                        if (item.actions === result.id) {
                          addedindex = index
                          updateDialogsOpen(addedindex, true)
                        }
                      })
                      closeSnackbar(creatingSnackbar)
                      enqueueSnackbar(
                        <Trans>Survey template created!</Trans>,
                        {
                          variant: 'info'
                        }
                      )
                    })
                  })
                }
                closeDialog()
              }}
            >
              <Trans>Create</Trans>
            </Button>
            <Button
              variant='contained'
              color='primary'
              style={{
                marginBottom: 10
              }}
              onClick={closeDialog}
            >
              <Trans>Cancel</Trans>
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
      <ChangeSubtemplatesOrderDialogue
        template={dialogSurvey}
        open={changeOrderDialogueOpen}
        saveRearrangment={(index, toSave) => {
          const modified = [...list]
          modified[index].children = toSave
          // this.setState({
          //   list: modified
          // })
          setList(modified)
        }}
        closeDialog={() => {
        // this.setState({
        //   changeOrderDialogueOpen: false,
        //   dialogSurvey: null
        // })
          setChangeOrderDialogueOpen(false)
          setDialogSurvey(null)
        }}
      />
      <DeleteSurveyTemplateDialog
        closeDialog={closeDialog}
        template={dialogSurvey}
        dialogChildrenIds={dialogChildrenIds}
        updateDialogsOpen={index => {
          updateDialogsOpen(index)
        }}
        fetchData={fetchData}
        warningDialogOpen={warningDialogOpen}
      />
      <div
        style={{
          paddingLeft: 15,
          marginTop: 20,
          paddingRight: 15,
          marginBottom: 20
        }}
      >
        <Grid
          container
          style={{ paddingBottom: 10 }}
          justifyContent='flex-end'
        >
          <ExportImportSurveysTranslationsPanel templates={data} />
        </Grid>

        <CustomDataTable
          title={
            <Grid container direction='row' alignItems='center'>
              <Typography 
                style={{
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "27px",
                letterSpacing: "-0.2px"
                }}
              >
                <Trans>Survey Templates</Trans>
              </Typography>
              <Button
                variant='contained'
                sx={{ marginLeft: 4 }}
                color='primary'
                onClick={e => {
                // this.setState({
                //   creatingDialogOpen: true,
                //   creatingSurveyOfType: 'parent'
                // })
                  setCreatingDialogOpen(true)
                  creatingSurveyOfType('parent')
                }}
              >
                <Grid container direction='row' alignItems='center'>
                  <Trans>Add new template</Trans>
                  <Icon style={{ marginLeft: 5 }}>add</Icon>
                </Grid>
              </Button>
            </Grid>
        }
          columns={[
            {
              name: 'name',
              label: myI18n._(t`Template Name`),
              options: {
                customHeadLabelRender: props => myI18n._(t`Template Name`),
                customBodyRender: (value, tableMeta, updateValue) => {
                  return <div style={{ flex: 1 }}>{value}</div>
                }
              }
            },
            {
              name: 'id',
              label: myI18n._(t`Id`),
              options: {
                customHeadLabelRender: props => myI18n._(t`Id`),
                customBodyRender: (value, tableMeta, updateValue) => {
                  return <div style={{ flex: 1 }}>{value}</div>
                }
              }
            },
            {
              name: 'actions',
              options: {
                sort: false,
                customHeadLabelRender: props => {
                  return null
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                  const id = value
                  const rowId = tableMeta.rowData[1]
                  const surveyData = data.find(obj => obj.id === rowId)
                  return (
                    (
                      <Grid
                        key={id}
                        container
                        direction='row'
                        justifyContent='flex-end'
                      >
                        <Tooltip title={<Trans>Edit survey template</Trans>}>
                          <IconButton
                            onClick={e =>
                              history.push(
                            `/surveys/CreateSurvey/${id}/${'parent'}`,
                            { id }
                              )}
                            size='large'
                          >
                            <EditOutlinedIcon/>
                          </IconButton>
                        </Tooltip>
                        {surveyData && surveyData.children?.length > 0 && (
                          <Tooltip
                            title={<Trans>Edit subtemplates order</Trans>}
                          >
                            <IconButton
                              onClick={e => {
                              // this.setState({
                              //   dialogSurvey: surveyData,
                              //   changeOrderDialogueOpen: true
                              // })
                                setDialogSurvey(surveyData)
                                setChangeOrderDialogueOpen(true)
                              }}
                              size='large'
                            >
                              <SwapVerticalCircleOutlinedIcon className='material-icons'/>
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip
                          title={<Trans>Duplicate survey template</Trans>}
                        >
                          <IconButton
                            disabled={duplicating}
                            onClick={e => {
                            // this.setState({
                            //   duplicating: true
                            // })
                              setDuplicating(true)

                              const duplicatingSnackbar =
                            enqueueSnackbar('', {
                              variant: 'info',
                              persist: true,
                              content: key =>
                                ProgressSnackbar(
                                  <Trans>Duplicating template</Trans>
                                )
                            })
                              duplicateSurveyTemplate(surveyData).then(
                                result => {
                                  fetchData().then(
                                    result => {
                                      closeSnackbar(
                                        duplicatingSnackbar
                                      )
                                      enqueueSnackbar(
                                        <Trans>Template duplicated</Trans>,
                                        {
                                          variant: 'success'
                                        }
                                      )
                                      // this.setState({
                                      //   duplicating: false
                                      // })
                                      setDuplicating(false)
                                    },
                                    reject => {
                                      enqueueSnackbar(
                                        <Trans>
                                          Error ocurred while duplicating
                                          template
                                        </Trans>,
                                        {
                                          variant: 'error'
                                        }
                                      )
                                      closeSnackbar(
                                        duplicatingSnackbar
                                      )
                                      // this.setState({
                                      //   duplicating: false
                                      // })
                                      setDuplicating(false)
                                    }
                                  )
                                }
                              )
                            }}
                            size='large'
                          >
                            <ContentCopyOutlinedIcon/>
                          </IconButton>
                        </Tooltip>
                        <PrintableReadyToFillSurvey data={surveyData} />
                        <Tooltip title={<Trans>Create subsurvey</Trans>}>
                          <IconButton
                            onClick={e => {
                            // this.setState({
                            //   creatingDialogOpen: true,
                            //   creatingSurveyOfType: 'child',
                            //   dialogSurvey: surveyData
                            // })
                              setCreatingDialogOpen(true)
                              setCreatingSurveyOfType('child')
                              setDialogSurvey(surveyData)
                            }}
                            size='large'
                          >
                            <Icon>add</Icon>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={<Trans>Delete survey template</Trans>}>
                          <IconButton
                            onClick={e => {
                              let childrenIds = []
                              surveyData.children.forEach(child =>
                                childrenIds.push(child.id)
                              )
                              if (childrenIds.length === 0) {
                                childrenIds = null
                              }
                              // this.setState({
                              //   warningDialogOpen: true,
                              //   dialogSurvey: surveyData,
                              //   dialogChildrenIds: childrenIds
                              // })
                              setWarningDialogOpen(true)
                              setDialogSurvey(surveyData)
                              setDialogChildrenIds(childrenIds)
                            }}
                            size='large'
                          >
                            <DeleteOutlinedIcon/>
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    )
                  )
                }
              }
            }
          ]}
          data={data}
          components={{
            ExpandButton: props => {
              if (
                props.dataIndex === undefined ||
              props.dataIndex >= data.length
              ) {
                return <div style={{ width: '24px' }} />
              }
              if (data[props.dataIndex].children.length > 0) {
                return (
                  <ExpandButton
                    {...props}
                    style={{ margin: 20 }}
                    onExpand={() => {
                      if (!panelsOpened.includes(props.dataIndex)) {
                        const newPanels = [...panelsOpened]
                        newPanels.push(props.dataIndex)
                        setPanelsOpened(newPanels)
                        console.log('NOW OPENED', panelsOpened)
                      } else {
                        const newPanels = [...panelsOpened]
                        newPanels.splice(
                          newPanels.indexOf(props.dataIndex),
                          1
                        )
                        setPanelsOpened(newPanels)
                        console.log('NOW OPENED', panelsOpened)
                      }
                      props.onExpand()
                    }}
                  />
                )
              }
              return <div style={{ width: '24px' }} />
            }
          }}
          options={{
            expandableRows: true,
            filter: false,
            sortOrder: { name: 'name', direction: 'asc' },
            selectableRows: 'none',
            print: false,
            download: false,
            viewColumns: false,
            rowsExpanded: panelsOpened,
            renderExpandableRow: (rowData, rowMeta) => {
              const colSpan = rowData.length + 1
              if (!list[rowMeta.dataIndex]) {
                return null
              }
              return list[rowMeta.dataIndex].children.map(
                (sub, index) => {
                  const id = sub.id
                  return (
                    (
                      <TableRow
                        key={index}
                        style={{ backgroundColor: '#dddddd' }}
                      >
                        <TableCell colSpan={colSpan}>
                          <div
                            style={{
                              marginLeft: 20
                            }}
                          >
                            <Grid container direction='row' alignItems='center'>
                              <div style={{ flex: 1, textAlign: 'center' }}>
                                {sub.name} {sub.id}
                              </div>
                              <Tooltip
                                title={<Trans>Edit survey template</Trans>}
                              >
                                <IconButton
                                  onClick={e => {
                                    history.push(
                                    `/surveys/CreateSurvey/${id}/${'sub'}`
                                    )
                                  }}
                                  size='large'
                                >
                                  <EditOutlinedIcon/>
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title={<Trans>Delete survey template</Trans>}
                              >
                                <IconButton
                                  onClick={e => {
                                    // this.setState({
                                    //   warningDialogOpen: true,
                                    //   dialogSurvey: sub,
                                    //   dialogChildrenIds: null
                                    // })
                                    setWarningDialogOpen(true)
                                    setDialogSurvey(sub)
                                    dialogChildrenIds(null)
                                  }}
                                  size='large'
                                >
                                  <DeleteOutlinedIcon/>
                                </IconButton>
                              </Tooltip>
                            </Grid>
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  )
                }
              )
            }
          }}
        />
      </div>
    </>
  )
}
